export const EVENTS = {
  HOME: {
    NEARBY_LOAD: 'home.nearby_load',
    NEARBY_LOADING: 'home.nearby_loading',
    NEARBY_LOADED: 'home.nearby_loaded',
    NEARBY_LOAD_ERROR: 'home.nearby_load_error',

    RECOMMENDED_LOAD: 'home.recommended_load',
    RECOMMENDED_LOADING: 'home.recommended_loading',
    RECOMMENDED_LOADED: 'home.recommended_loaded',
    RECOMMENDED_LOAD_ERROR: 'home.recommended_load_error',

    POPULAR_RESTAURANTS_LOAD: 'home.popular_restaurants_load',
    POPULAR_RESTAURANTS_LOADING: 'home.popular_restaurants_loading',
    POPULAR_RESTAURANTS_LOADED: 'home.popular_restaurants_loaded',
    POPULAR_RESTAURANTS_LOAD_ERROR: 'home.popular_restaurants_load_error',

    NEW_RESTAURANTS_LOAD: 'home.new_restaurants_load',
    NEW_RESTAURANTS_LOADING: 'home.new_restaurants_loading',
    NEW_RESTAURANTS_LOADED: 'home.new_restaurants_loaded',
    NEW_RESTAURANTS_LOAD_ERROR: 'home.new_restaurants_load_error',

    CATEGORIES_LOAD: 'home.categories_load',
    CATEGORIES_LOADING: 'home.categories_loading',
    CATEGORIES_LOADED: 'home.categories_loaded',
    CATEGORIES_LOAD_ERROR: 'home.categories_load_error',

    ADS_LOAD: 'home.ads_load',
    ADS_LOADING: 'home.ads_loading',
    ADS_LOADED: 'home.ads_loaded',
    ADS_LOAD_ERROR: 'home.ads_load_error',

    COUPONS_LOAD: 'home.coupons_load',
    COUPONS_LOADING: 'home.coupons_loading',
    COUPONS_LOADED: 'home.coupons_loaded',
    COUPONS_LOAD_ERROR: 'home.coupons_load_error',

    SPONSORSHIPS_LOAD: 'home.sponsorships_load',
    SPONSORSHIPS_LOADING: 'home.sponsorships_loading',
    SPONSORSHIPS_LOADED: 'home.sponsorships_loaded',
    SPONSORSHIPS_LOAD_ERROR: 'home.sponsorships_load_error',
    
    ALL_RESTAURANTS_LOAD: 'home.all_restaurants_load',
    ALL_RESTAURANTS_LOADING: 'home.all_restaurants_loading',
    ALL_RESTAURANTS_LOADED: 'home.all_restaurants_loaded',
    ALL_RESTAURANTS_LOAD_ERROR: 'home.all_restaurants_load_error',

    // NOUVEAU — Deals
    DEALS_LOAD: 'home.deals_load',
    DEALS_LOADING: 'home.deals_loading',
    DEALS_LOADED: 'home.deals_loaded',
    DEALS_LOAD_ERROR: 'home.deals_load_error'
  }
};

export const ENDPOINTS = {
  HOME: {
    NEARBY: 'https://api.monrapidoo.com/rapidoo-aggregation/dishes/nearby?group=ultraxeno&isPublished=true&radius=100',
    RECOMMENDED: 'https://api.monrapidoo.com/rapidoo-aggregation/dishes/recommended?group=ultraxeno&isPublished=true',
    POPULAR: '/restaurant/popular?group=ultraxeno&status=approved',
    NEW: '/restaurant/new?group=ultraxeno&status=approved',
    CATEGORIES: '/categories/list?group=ultraxeno',
    ADS: '/ads/list?group=ultraxeno&position=home&active=true&targetAudience=client',
    COUPONS: '/coupons/list?group=ultraxeno',
    SPONSORSHIPS: '/sponsorship/list?group=ultraxeno&status=paid',
    ALL_RESTAURANTS: '/restaurant/list?group=ultraxeno&status=approved',
    RESTAURANT_DETAIL: '/restaurant/details/{id}?group=ultraxeno',
    DEALS: 'https://api.monrapidoo.com/rapidoo-aggregation/deals?group=ultraxeno&isPublished=true&startDate=2026-01-01'
  }
};

export const CATEGORIES = [
  {
    id: 'african',
    name: 'Africain',
    icon: '/images/categories/african.svg',
    color: 'bg-primary-500'
  },
  {
    id: 'fast-food',
    name: 'Fast Food',
    icon: '/images/categories/fast-food.svg',
    color: 'bg-orange-500'
  },
  {
    id: 'italian',
    name: 'Italien',
    icon: '/images/categories/italian.svg',
    color: 'bg-red-500'
  },
  {
    id: 'chinese',
    name: 'Chinois',
    icon: '/images/categories/chinese.svg',
    color: 'bg-rose-500'
  },
  {
    id: 'mexican',
    name: 'Mexicain',
    icon: '/images/categories/mexican.svg',
    color: 'bg-lime-500'
  },
  {
    id: 'french',
    name: 'Français',
    icon: '/images/categories/french.svg',
    color: 'bg-blue-500'
  },
  {
    id: 'traditional',
    name: 'Traditionnel',
    icon: '/images/categories/traditional.svg',
    color: 'bg-green-500'
  },
  {
    id: 'desserts',
    name: 'Desserts',
    icon: '/images/categories/desserts.svg',
    color: 'bg-pink-500'
  },
  {
    id: 'drinks',
    name: 'Boissons',
    icon: '/images/categories/drinks.svg',
    color: 'bg-cyan-500'
  },
  {
    id: 'healthy',
    name: 'Healthy',
    icon: '/images/categories/healthy.svg',
    color: 'bg-emerald-500'
  },
  {
    id: 'grilled',
    name: 'Grillades',
    icon: '/images/categories/grilled.svg',
    color: 'bg-red-600'
  },
  {
    id: 'seafood',
    name: 'Fruits de mer',
    icon: '/images/categories/seafood.svg',
    color: 'bg-sky-500'
  },
  {
    id: 'vegetarian',
    name: 'Végétarien',
    icon: '/images/categories/vegetarian.svg',
    color: 'bg-lime-600'
  },
  {
    id: 'indian',
    name: 'Indien',
    icon: '/images/categories/indian.svg',
    color: 'bg-orange-600'
  },
  {
    id: 'japanese',
    name: 'Japonais',
    icon: '/images/categories/japanese.svg',
    color: 'bg-red-400'
  },
  {
    id: 'thai',
    name: 'Thaïlandais',
    icon: '/images/categories/thai.svg',
    color: 'bg-violet-500'
  }
];
